<main>
  <app-calendar></app-calendar>
</main>
